import { Icon } from "PFComponents/icon";
import { IconProps } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";

import css from "./skill.module.scss";

type ActionOptionProps = {
  label: string;
  iconProps: IconProps;
};

export const ActionOption = ({ label, iconProps }: ActionOptionProps) => (
  <div className={css.skillAction}>
    <Icon {...iconProps} />
    <Typography variant="bodyRegular">{label}</Typography>
  </div>
);
